export default __webpack_public_path__ + "static/stn-1b6fd1aa9ee0088ef2798f4bee9c448b.svg";